import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import CoursesAdmin from './Courses';
import CoursesSeller from './CoursesSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function CoursesIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <CoursesAdmin />
			break;
		case '2':
			component = <CoursesSeller />
			break;
		case '3':
			component = <CoursesSeller />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
